<script setup lang="ts">
import { locale } from "../../../../locale";
import { activeRoomState } from "../../../../states/active_room";
import BasePopoverItem from "./BasePopoverItem.vue";
const props = defineProps<{
  close: () => void;
}>();
const changeMode = () => {
  if (activeRoomState.mode === "grid") {
    activeRoomState.mode = "speaker";
  } else if (activeRoomState.mode === "speaker") {
    activeRoomState.mode = "grid";
  } else if (activeRoomState.mode === "one") {
    activeRoomState.mode = "grid";
  }
  props.close();
};
</script>
<template>
  <BasePopoverItem
    :text="locale.changeMode"
    :inactive="activeRoomState.mode === 'stream'"
    @click.stop="changeMode"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.75"
        y="0.75"
        width="6.5"
        height="8.5"
        rx="0.989131"
        transform="matrix(-1 0 0 1 17.5 1)"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <rect
        x="-0.75"
        y="0.75"
        width="6.5"
        height="4.5"
        rx="0.989131"
        transform="matrix(-1 0 0 1 7.5 1)"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <rect
        x="-0.75"
        y="0.75"
        width="6.5"
        height="4.5"
        rx="0.989131"
        transform="matrix(-1 0 0 1 17.5 13)"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <rect
        x="-0.75"
        y="0.75"
        width="6.5"
        height="8.5"
        rx="0.989131"
        transform="matrix(-1 0 0 1 7.5 9)"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </svg>
  </BasePopoverItem>
</template>
